import { createFileRoute } from '@tanstack/react-router'
import { BulkPatientImportPage } from '@/features/patients/import'

export const Route = createFileRoute('/patients_/import')({
  component: RouteComponent,
})

function RouteComponent() {
  const search = Route.useSearch()
  return (
    <BulkPatientImportPage
      companyId={search?.companyId}
      companyName={search?.companyName}
    />
  )
}
